export enum DateRangeMode {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal'
}
